import { Injectable } from '@angular/core';
import { CommonHttpService } from './http.service';
import { Response } from '@angular/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class AppsService {
    private loadingSource: Subject<any> = new Subject();
    private loadedSource: Subject<any> = new Subject();
    public apps: Array<any> = [];
    public loading$ = this.loadingSource.asObservable();
    public loaded$ = this.loadedSource.asObservable();

    constructor(
        protected http: CommonHttpService
    ) {
        this.init();
    }

    /**
     * This instances new Subjects and observables.
     **/
    private init() {
        this.loadingSource = new Subject();
        this.loadedSource = new Subject();
        this.loading$ = this.loadingSource.asObservable();
        this.loaded$ = this.loadedSource.asObservable();
    }

    /**
     * Call GET request to resolve data load.
     **/
    public dataLoad() {
        this.loadingSource.next(null);
        this.loadingSource.complete();

        this.http
            .get('/_data?scope=apps')
            .subscribe((response: Response) => {
                const apps = response.json().data['apps'];

                this.loadedSource.next(apps);
                this.loadedSource.complete();

                this.init();
            });
    }

    /**
     * Compare values with app by informed key.
     **/
    public is(key: string, value: any): boolean {
        if (this.has(key)) {
            return this.get(key) === value;
        }

        return false;
    }

    /**
     * Find app at object by key.
     **/
    public get(key: string, def = null): any {
        if (!this.has(key)) {
            return def;
        }

        return this.apps.filter((config) => {
            return config.key === key;
        })[0];
    }

    /**
     * Find app at object by key.
     **/
    public has(key: string): any {
        return this.apps.filter((config) => {
            return config.key === key;
        }).length > 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/services/apps.service.ts